import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link, useHistory } from "react-router-dom"
import { useLocation, useParams } from "react-router"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
import imageBaseUrl from "../../../helpers/imageBaseUrl"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"

import {
  Title,
  CeremonyNameEn,
  Date
} from "./Vendor_mediaListCol"

//redux
import { useSelector, useDispatch } from "react-redux"

import {
  Col,
  Row,
  UncontrolledTooltip,
  Card,
  CardBody,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import DeleteModal from "../../../components/Common/DeleteModal"
import {
  addNewVendor,
  deleteVendor,
  updateVendor,
} from "../../../store/vendor/actions"
import { deleteVendor_media, getVendor_media, updateVendor_media } from "../../../store/vendor_media/actions"

function VendorMediaList() {
  const history = useHistory()
  const params = useParams()
  const location = useLocation()


  const [vendor, setVendor] = useState([])
  const [selectedFiles, setselectedFiles] = useState([])
  const [offset,setOffset] = useState(0)
  const [page_size, setPageSize] = useState(10)
  const dispatch = useDispatch()
  const vendors = useSelector(state => state.vendors.vendor_media.data)
  const total_page = useSelector(state => state.vendors.vendor_media.total_page)
  const loading = useSelector(state => state.vendors.vendor_media.loading)

  useEffect(() => {
    // if (vendors && !vendors.length) {
    dispatch(getVendor_media({id:params.vendor_id,offset,page_size}))
    // }
  }, [dispatch,offset,page_size])


  const handleUserClick = useCallback(
    arg => {
      const vendor = arg
      history.push("/vendors/add", vendor)
    },
    [history]
  )

  //delete vendor
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = vendor => {
    setVendor(vendor)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {

    if (vendor.id) {
      dispatch(deleteVendor_media(vendor))
    }
  }
  useEffect(() => {
    if (!loading) {
      setDeleteModal(false)
    }
  }, [loading])
  const handleUserClicks = () => {
    history.push("/vendors/add-media/" + params.vendor_id, {
      vendor_name: location?.state?.vendor_name,
    })
  }

  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   accessor: "checkbox",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: cellProps => {
      //     return <input type="checkbox" className="selection-input-4" />
      //   },
      // },
      {
        Header: "Logo",

        filterable: true,
        disableFilters: true,
        accessor: cellProps => (
          <React.Fragment>
            {!cellProps.image ? (
              <div className="avatar-sm d-inline-block me-2">
                <div className="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i className="mdi mdi-account-circle m-0"></i>
                </div>
              </div>
            ) : (
              <>
                <img
                  className="avatar-sm rounded-circle me-2"
                  src={imageBaseUrl + cellProps?.image}
                  alt=""
                />
              </>
            )}
          </React.Fragment>
        ),
      },
      {
        Header: "Title",
        accessor: "title",
        filterable: true,
        Cell: cellProps => {
          return <Title {...cellProps} />
        },
      },
      {
        Header: "Ceremony",
        accessor: "ceremony_name_en",
        filterable: true,
        Cell: cellProps => {
          return <CeremonyNameEn {...cellProps} />
        },
      },
      {
        Header: "date",
        accessor: "date",
        filterable: true,
        Cell: cellProps => {
          return <Date {...cellProps} />
        },
      },
      {
        Header: "Active",
        accessor: "is_active",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          // {
          //   return <IsActive {...cellProps} />
          // },
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value == 1 ? (
              <input
                disabled={loading}
                onChange={() => {}}
                onClick={e =>
                  dispatch(
                    updateVendor_media(
                      {
                        is_active: 0,
                        id: cellProps.row.original.id,
                      },
                      null
                    )
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={true}
              />
            ) : (
              <input
                onChange={() => {}}
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateVendor_media(
                      {
                        is_active: 1,
                        id: cellProps.row.original.id,
                      },
                      null
                    )
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to={{
                      pathname: "/vendors/edit-media",
                      state: cellProps.row.original,
                    }}
                    className="text-primary"
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    // to="#"
                    className="text-danger"
                    onClick={() => {
                      const vendors = cellProps.row.original
                      onClickDelete(vendors)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
                {/* <li className="list-inline-item dropdown">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem
                        onClick={() =>
                          history.push(
                            `/vendor/media/${cellProps.row.original.id}`,
                            { vendor_name: cellProps.row.original.name }
                          )
                        }
                      >
                        Show media
                      </DropdownItem>
                      <DropdownItem href="#">Another action</DropdownItem>
                      <DropdownItem href="#">Something else here</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li> */}
              </ul>
            </div>
          )
        },
      },
    ],
    [handleUserClick]
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="MENU"
            breadcrumbItem={location?.state?.vendor_name}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={vendors}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={setOffset}
                    page_number={offset}
                    total_pages={total_page}
                    setPageSize={setPageSize}
                    page_size={page_size}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}
VendorMediaList.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default VendorMediaList
